import { render, staticRenderFns } from "./DB.vue?vue&type=template&id=49ef7070&scoped=true"
import script from "./DB.vue?vue&type=script&lang=js"
export * from "./DB.vue?vue&type=script&lang=js"
import style0 from "./DB.vue?vue&type=style&index=0&id=49ef7070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ef7070",
  null
  
)

export default component.exports